module.exports = __webpack_public_path__ + "static/media/1001024.e98e5333.png";